function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "nonzero",
  d: "M5 18.992L9.997 19 10 5.008 5.003 5 5 18.992zm-1-12.7c-.002-.609.103-1.194.292-1.625.188-.431.444-.671.711-.667h4.994c.267-.004.523.236.711.667.189.43.294 1.016.292 1.626v11.414c.002.61-.103 1.195-.292 1.626-.188.431-.444.671-.711.667H5.003c-.267.004-.523-.236-.711-.667-.189-.43-.294-1.016-.292-1.626V6.293zm10 3.705l4.997.003L19 5.003 14.003 5 14 9.997zm-1-4.994c-.002-.267.103-.523.292-.711.188-.189.444-.294.711-.292h4.994c.267-.002.523.103.711.292.189.188.294.444.292.711v4.994c.002.267-.103.523-.292.711-.188.189-.444.294-.711.292h-4.994c-.267.002-.523-.103-.711-.292-.189-.188-.294-.444-.292-.711V5.003zm1 13.994l4.997.003.003-4.997L14.003 14 14 18.997zm-1-4.994c-.002-.267.103-.523.292-.711.188-.189.444-.294.711-.292h4.994c.267-.002.523.103.711.292.189.188.294.444.292.711v4.994c.002.267-.103.523-.292.711-.188.189-.444.294-.711.292h-4.994c-.267.002-.523-.103-.711-.292-.189-.188-.294-.444-.292-.711v-4.994z"
}));

var SvgSemiGridView = function SvgSemiGridView(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSemiGridView, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/semi-grid-view.4475b149.svg";
export { ForwardRef as ReactComponent };